import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { AsyncStatus } from '../../../libs/utils/constants/async-status';
import IAppConfigs, {
    IPublicAppConfigValues,
    IRuntimeAppConfigValues,
} from '../../../libs/utils/interfaces/app-config-interface';
import { getAppConfigs, getAppRuntimeConfigs } from './app-config-thunk';

const initialState = {
    appConfigsAsyncStatus: AsyncStatus.INITIAL,
    appRuntimeConfigsAsyncStatus: AsyncStatus.INITIAL,
    appConfigs: {},
} as IAppConfigs;
const appConfigSlice = createSlice({
    name: 'appConfig',
    initialState,
    reducers: {},
    extraReducers(builder: any) {
        builder
            // fetch App-Config Values
            .addCase(getAppConfigs.pending, (state: IAppConfigs) => {
                state.appConfigsAsyncStatus = AsyncStatus.LOADING;
            })
            .addCase(
                getAppConfigs.fulfilled,
                (
                    state: IAppConfigs,
                    { payload }: PayloadAction<IPublicAppConfigValues>
                ) => {
                    state.appConfigsAsyncStatus = AsyncStatus.SUCCESS;
                    state.appConfigs = payload;
                }
            )
            .addCase(getAppConfigs.rejected, (state: IAppConfigs) => {
                state.appConfigsAsyncStatus = AsyncStatus.FAILURE;
            })
            // fetch post-login App-Runtime-Config values
            .addCase(getAppRuntimeConfigs.pending, (state: IAppConfigs) => {
                state.appRuntimeConfigsAsyncStatus = AsyncStatus.LOADING;
            })
            .addCase(
                getAppRuntimeConfigs.fulfilled,
                (
                    state: IAppConfigs,
                    { payload }: PayloadAction<IRuntimeAppConfigValues>
                ) => {
                    state.appRuntimeConfigsAsyncStatus = AsyncStatus.SUCCESS;
                    state.appConfigs = { ...state.appConfigs, ...payload };
                }
            )
            .addCase(getAppRuntimeConfigs.rejected, (state: IAppConfigs) => {
                state.appRuntimeConfigsAsyncStatus = AsyncStatus.FAILURE;
            });
    },
});

export default appConfigSlice.reducer;
